module.exports = __webpack_public_path__ + "static/media/Milk-TeaAtdusk.14f70497.jpg";